// src/utils/formatters.js — display helpers
export const TYPE_PREFIX = { incident: 'INT', service_request: 'SR', hardware: 'HW' };

export function ticketCode(t, index) {
  if (!t) return '';
  const prefix = TYPE_PREFIX[t.ticket_type || 'incident'] || 'INT';
  const id = t.id || (index !== undefined ? index + 1 : 0);
  const num = String(id).padStart(2, '0');
  return `BST-${prefix}${num}`;
}

export function fmtDate(s) {
  if (!s) return '—';
  return new Date(s).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' });
}

export function fmtDateTime(s) {
  if (!s) return '—';
  return new Date(s).toLocaleString('en-GB', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' });
}

export function statusClass(status) {
  const map = { 'Open':'badge-open','In Progress':'badge-progress','On Hold':'badge-pending',
    'Resolved':'badge-resolved','Closed':'badge-closed','Reopened':'badge-reopened','Waiting':'badge-pending' };
  return `badge ${map[status] || 'badge-closed'}`;
}

export function priorityClass(p) {
  const norm = p ? (p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()) : '';
  const map = { Low: 'badge-low', Medium: 'badge-medium', High: 'badge-high', Critical: 'badge-critical' };
  return `badge ${map[norm] || 'badge-low'}`;
}

export function priorityLabel(p) {
  if (!p) return '';
  return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
}
export function timeAgo(date) {
  if (!date) return '—';
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  let interval = seconds / 31536000;
  if (interval > 1) return Math.floor(interval) + " years ago";
  interval = seconds / 2592000;
  if (interval > 1) return Math.floor(interval) + " months ago";
  interval = seconds / 86400;
  if (interval > 1) return Math.floor(interval) + " days ago";
  interval = seconds / 3600;
  if (interval > 1) return Math.floor(interval) + " hours ago";
  interval = seconds / 60;
  if (interval > 1) return Math.floor(interval) + " minutes ago";
  return "just now";
}

export function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((res, rej) => {
      document.execCommand('copy') ? res() : rej();
      textArea.remove();
    });
  }
}
